// extracted by mini-css-extract-plugin
export var faqList = "sectionFaq-module--faqList--5d1c9";
export var hasIcon = "sectionFaq-module--hasIcon--71959";
export var richtext = "sectionFaq-module--richtext--5d526";
export var section = "sectionFaq-module--section--14bf8";